import { useState, useEffect } from 'react';
import axios from 'axios';
import CONSTS from '../Constants.js';
import Loader from '../Loader';
import WelcomeThanks from './WelcomeThanks';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import t from '../translations/translate.ts';

export default function SignUpPendingSubmit({
    familyInviteToken, familyInfo, firstName, lastName,
    phoneNumber, phoneCode, otpCode, onSuccess
}) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        async function submit() {
            try {
                const response = await axios.post(`${CONSTS.BASE_API_URL}/supporters/signup`, {
                    invitation: familyInviteToken,
                    supporter: {
                        first_name: firstName,
                        last_name: lastName,
                        phone_number: phoneCode + phoneNumber,
                    },
                    code: otpCode
                }, {
                    headers: { 'Content-Type': 'application/json' }
                });
                setLoading(false);
                onSuccess();
            } catch (err) {
                console.log("signup error", err);
                setLoading(false);
                setError(true);
                if (err.response && err.response.data && err.response.data.error) {
                    NotificationManager.error(err.response.data.error, t('signUpRequestError'));
                } else {
                    NotificationManager.error(err.toString(), t('signUpRequestError'));
                }
            }
        }
        submit();
    }, []);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div style={{ padding: 20, textAlign: 'center' }}>
            <p>{t('signUpRequestError')}</p>
            <button onClick={() => window.location.reload()}>{t('tryAgain') || 'Try again'}</button>
            <NotificationContainer />
        </div>;
    }

    return <WelcomeThanks familyName={familyInfo.title} firstName={firstName} lastName={lastName} />;
}
